import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestCountryBypassDatabasePut = {
    path: "/country-bypass/database",
    method: RouteHttpVerb.PUT
};
